module.exports = __webpack_public_path__ + "static/media/(000007).3efe4a9a.jpg";